import BaseStore         from '../../../App/Data/Store/BaseStore';
import CodeOutputFactory from '../Outputs/CodeOutputFactory';
import ColorPreview      from '../Outputs/Options/ColorPreview';

export default class CodeOutput extends BaseStore {

    module = ['CodeOutput'];

    outputter() {
        return this.state('outputter');
    }

    context() {
        return this.state('context');
    }

    format() {
        return this.state('format');
    }

    options(type = '') {
        let options = this.state('options');

        if(type) {
            options = options[type + 'Options'];
        }
        return options;
    }

    availableOptions() {
        return [...this.context().availableOptions, ...this.format().availableOptions];
    }

    hasOption(option, type = 'format') {
        return this.options(type).includes(option);
    }

    resetOptions() {
        this.setOptions([], 'format');
        this.setOptions([], 'context');
        this.setOptions([], 'line');

        this.setOptionsToDefaults();
    }

    setOptionsToDefaults() {
        let available = this.availableOptions();

        available.forEach(option => {
            if(option.default === true)
                this.pushOption(option, option.type);
        });
    }

    setContext(context) {
        this.commit('setContext', context);
    }

    setFormat(format) {
        this.commit('setFormat', format);
    }

    setOptions(options = [], type = 'format') {
        this.commit('setOptions', {type: `${type}Options`, options});
    }

    pushOption(option, type = 'format') {
        let options = this.options(type);
        options.push(option);

        this.setOptions(options, type);
    }


    removeOption(option, type = 'format') {
        let options = this.options(type);

        let i = options.findIndex(item => item === option);

        options.splice(i, 1);

        this.setOptions(options, type);
    }

    updateOutputter(palette) {
        this.commit(
            'setOutputter',
            new CodeOutputFactory(palette, {
                context: this.context(),
                contextOptions: this.options('context'),
                lineOptions: [ColorPreview],
                format: this.format(),
                formatOptions: this.options('format'),
            }).make(),
        );
    }


}